import React from 'react'
import "../../CSS/Blog/Dinogame.css"
import FooTer from "../footer"
export default function ChromeDino() {
    return (
        <>
            <div id="maincontent">
                <h1 id="start">Let's Fun With Chrome Dino Game</h1>
                <hr />
                <h1 className="hd">This Video Fun With Chrome Dino Game Hacked</h1>
                <div className="phishing-yt">
                    <iframe id="yt" src="https://www.youtube.com/embed/GoqWzOZowpU" title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                </div>
                <div className="yt-visit">
                    <h1 id="sub">
                        If You Guys Injoy My Video So Visit My Youtube Channel:
                    </h1>
                    <a id="cd" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" rel="noreferrer" target="_blank"><button>Code Arindam</button></a>
                </div>
                <p className="ans">
                    In This Video Using: <br />
                    <br />
                    1) Chrome Extension<br />
                    2) Javascript(JS)<br />
                </p>
                <h2 className="q">
                    Ultimate Dino Runner Code Mention Below...
                </h2>
                <p className="ans">
                    var original = Runner.prototype.gameOver<br />
                    Runner.prototype.gameOver = function (){ }
                </p>
                <h1 className="last">
                    So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
                </h1>
                <FooTer/>
            </div>
        </>
    )
}
